import { observer } from "mobx-react-lite";
import { MDSButton, MDSButtonGroup, MDSButtonVariant, MDSDialogTextContent } from "@/mds";
import { useTabPageStore } from "@/hooks/useTabPageStore";
import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds";
import { MDSModalDialog } from "@/mds";
import { MDSDialogSlotName } from "@/mds/components/overlays/dialog/dialog.types";

interface ConfirmEmptyTrashModalProps {}

export const ConfirmEmptyTrashModal = observer<ConfirmEmptyTrashModalProps>(
  function ConfirmEmptyTrashModal() {
    const page = useTabPageStore("trashPage");
    return (
      <MDSModalDialog isOpen={page.showConfirmModal} handleClose={page.closeConfirmModal}>
        <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
          Empty trash now?
        </MDSText>
        <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
          <MDSText variant={MDSTextVariant.ParagraphS}>
            {"Make sure you want to empty Trash now, permanently deleting all items in Trash. "}
          </MDSText>
          <MDSText variant={MDSTextVariant.ParagraphS} weight={MDSTextWeight.SemiBold}>
            You cannot undo this action.
          </MDSText>
        </MDSDialogTextContent>
        <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
          {!page.isEmptyingTrash && <MDSButton onClick={page.closeConfirmModal}>Cancel</MDSButton>}
          <MDSButton
            variant={MDSButtonVariant.DangerFilled}
            isLoading={page.isEmptyingTrash}
            onClick={page.emptyTrash}
          >
            Empty trash now
          </MDSButton>
        </MDSButtonGroup>
      </MDSModalDialog>
    );
  }
);
